export default "/fonts/vendor/boxicons/boxicons.ttf?22afc8ee5cfc540cddff22c5cf831ed1";